import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";

// Data statis untuk Wilderness Features, Event Schedule, dan Mandatory Gears
export const wildernessFeatures = [
  {
    title: "Mount Rinjani Trails",
    description: "Indonesia's second highest volcano with extreme terrain",
  },
  {
    title: "Segara Anak Crater Lake",
    description: "Stunning crater lake views from high altitude",
  },
  {
    title: "Remote Mountain Villages",
    description: "Pass through isolated Sasak communities",
  },
  {
    title: "Pristine Wilderness",
    description: "Untouched natural landscapes and wildlife",
  },
];

export const eventSchedule = [
  {
    title: "Race Pack Collection & UMKM",
    date: "Jumat, 18 September 2026",
    time: "10:00 - 18:00 WITA",
  },
  {
    title: "Race Briefing — Porter Pergasingan Challenge & Kaldera Kids Run",
    date: "Jumat, 18 September 2026",
    time: "15:00 - 16:00 WITA",
  },
  {
    title: "Festival UMKM",
    date: "Sabtu, 19 September 2026",
    time: "09:00 - 20:00 WITA",
  },
  {
    title: "Race Pack Collection",
    date: "Sabtu, 19 September 2026",
    time: "09:00 - 18:00 WITA",
  },
  {
    title: "Race Briefing — 7K, Half Marathon & Marathon",
    date: "Sabtu, 19 September 2026",
    time: "15:00 - 16:00 WITA",
  },
  {
    title: "Opening Ceremony SMMF",
    date: "Sabtu, 19 September 2026",
    time: "16:00 WITA",
  },
  {
    title: "Flag-off Porter Pergasingan Challenge",
    date: "Sabtu, 19 September 2026",
    time: "16:30 WITA",
  },
  {
    title: "Flag-off Kaldera Kids Run",
    date: "Sabtu, 19 September 2026",
    time: "16:35 WITA",
  },
  {
    title: "Flag-off Half Marathon & Marathon",
    date: "Minggu, 20 September 2026",
    time: "06:00 WITA",
  },
  {
    title: "Flag-off 7K (Fun Run)",
    date: "Minggu, 20 September 2026",
    time: "07:00 WITA",
  },
  {
    title: "Festival UMKM",
    date: "Minggu, 20 September 2026",
    time: "09:00 - 21:00 WITA",
  },
  {
    title: "Award Ceremony — Kategori 7K",
    date: "Minggu, 20 September 2026",
    time: "11:00 - 12:00 WITA",
  },
  {
    title: "Award Ceremony — Half Marathon & Marathon",
    date: "Minggu, 20 September 2026",
    time: "13:00 - 14:00 WITA",
  },
  {
    title: "Panggung Sembalun Festival",
    date: "Minggu, 20 September 2026",
    time: "18:30 - 21:00 WITA",
  },
  {
    title: "Penutupan SMMF",
    date: "Minggu, 20 September 2026",
    time: "21:00 WITA",
  },
];

// Intro / paragraph yang muncul di bawah title "Qualification & Race Inclusions"
export const qualificationIntro =
  "The following criteria and rules apply to all entrants. You must meet at least one of the following qualifying performances (times must be from an official race event).";

// PER-CATEGORY OVERRIDES
// Use exact categoryName from event.categories[].categoryName as key
export const qualificationByCategory = {
  Marathon: [
    "Has completed at least one marathon (road race) within the past year; or",
    "Has trail running race experience of at least 20K.",
  ],
  "Half Marathon": [
    "Has completed at least one 10 km road or trail race within the past year.",
  ],
  "7 KM": [
    "No qualification required. Open to all participants in good physical condition.",
  ],
  "Kaldera Kids Run": [
    "Open for children. No qualification required.",
  ],
  "Porter Challenge": [
    "Open to all participants. No qualification required.",
  ],
};

export const raceInclusionsByCategory = {
  Marathon: [
    "Running T-shirt",
    "Finisher Medal",
    "Bib Number + RFID Chip",
    "Aid Stations (Refreshment, Meals, Medic Team)",
    "Post Refreshment",
    "The entrance fee for Mount Rinjani National Park",
    "E-certificate Finisher",
    "Photo Documentation",
  ],
  "Half Marathon": [
    "Running T-shirt",
    "Finisher Medal",
    "Bib Number + RFID Chip",
    "Aid Stations (Refreshment, Meals, Medic Team)",
    "Post Refreshment",
    "The entrance fee for Mount Rinjani National Park",
    "E-certificate Finisher",
    "Photo Documentation",
  ],
  "7 KM": [
    "Running T-shirt",
    "Finisher Medal",
    "Bib Number + RFID Chip",
    "Aid Stations",
    "Post Refreshment",
    "Photo Documentation",
  ],
  "Kaldera Kids Run": [
    "Running T-shirt",
    "Finisher Medal",
    "Bib Number + RFID Chip",
    "Post Refreshment",
    "E-certificate Finisher",
    "Photo Documentation",
  ],
  "Porter Challenge": [
    "Running T-shirt",
    "Finisher Medal",
    "Bib Number + RFID Chip",
    "Aid Stations",
    "Post Refreshment",
    "Photo Documentation",
  ],
};

// Global fallback defaults
export const qualification = [
  "Please refer to specific category requirements.",
];

export const raceInclusions = ["Running T-shirt", "Finisher Medal", "Bib Number + RFID Chip"];

// === SMM Mandatory Gears - berbagai kategori ===
export const mandatoryGearsSMM = {
  Marathon: [
    { gear: "Running Vest/Belt", mandatory: true, recommended: false },
    {
      gear: "Mobile Phone with GPX Route",
      mandatory: true,
      recommended: false,
    },
    { gear: "Smartwatch", mandatory: false, recommended: true },
    {
      gear: "Minimum Water Supply of 500ml",
      mandatory: true,
      recommended: false,
    },
    { gear: "Foldable Cup", mandatory: true, recommended: false },
    { gear: "Survival Blanket", mandatory: true, recommended: false },
    { gear: "First Aid Kits", mandatory: true, recommended: false },
    { gear: "Snack/Energy Bar", mandatory: true, recommended: false },
    { gear: "Windproof Jacket", mandatory: true, recommended: false },
    { gear: "Rainproof Jacket/Poncho", mandatory: true, recommended: false },
    { gear: "ID Card", mandatory: true, recommended: false },
    { gear: "Whistle", mandatory: true, recommended: false },
    { gear: "Headlamp", mandatory: true, recommended: false },
    { gear: "Cap/Bandana", mandatory: false, recommended: true },
    { gear: "Running Shoes", mandatory: true, recommended: false },
    { gear: "Sufficient Cash", mandatory: false, recommended: true },
    { gear: "Trekking Poles", mandatory: true, recommended: false },
  ],
  "Half Marathon": [
    { gear: "Running Vest/Belt", mandatory: true, recommended: false },
    {
      gear: "Mobile Phone with GPX Route",
      mandatory: true,
      recommended: false,
    },
    { gear: "Smartwatch", mandatory: false, recommended: true },
    {
      gear: "Minimum Water Supply of 500ml",
      mandatory: true,
      recommended: false,
    },
    { gear: "Foldable Cup", mandatory: true, recommended: false },
    { gear: "Survival Blanket", mandatory: false, recommended: true },
    { gear: "First Aid Kits", mandatory: true, recommended: false },
    { gear: "Snack/Energy Bar", mandatory: false, recommended: true },
    { gear: "Windproof Jacket", mandatory: false, recommended: true },
    { gear: "Rainproof Jacket/Poncho", mandatory: true, recommended: false },
    { gear: "ID Card", mandatory: true, recommended: false },
    { gear: "Whistle", mandatory: true, recommended: false },
    { gear: "Headlamp", mandatory: true, recommended: false },
    { gear: "Cap/Bandana", mandatory: false, recommended: true },
    { gear: "Running Shoes", mandatory: true, recommended: false },
    { gear: "Sufficient Cash", mandatory: false, recommended: true },
    { gear: "Trekking Poles", mandatory: false, recommended: true },
  ],
  "7 KM": [
    { gear: "Running Vest/Belt", mandatory: false, recommended: true },
    {
      gear: "Mobile Phone with GPX Route",
      mandatory: false,
      recommended: true,
    },
    { gear: "Smartwatch", mandatory: false, recommended: true },
    {
      gear: "Minimum Water Supply of 500ml",
      mandatory: true,
      recommended: false,
    },
    { gear: "Foldable Cup", mandatory: false, recommended: true },
    { gear: "Survival Blanket", mandatory: false, recommended: true },
    { gear: "First Aid Kits", mandatory: true, recommended: false },
    { gear: "Snack/Energy Bar", mandatory: false, recommended: true },
    { gear: "Windproof Jacket", mandatory: false, recommended: true },
    { gear: "Rainproof Jacket/Poncho", mandatory: false, recommended: true },
    { gear: "ID Card", mandatory: true, recommended: false },
    { gear: "Whistle", mandatory: true, recommended: false },
    { gear: "Headlamp", mandatory: false, recommended: true },
    { gear: "Cap/Bandana", mandatory: false, recommended: true },
    { gear: "Running Shoes", mandatory: true, recommended: false },
    { gear: "Sufficient Cash", mandatory: false, recommended: true },
    { gear: "Trekking Poles", mandatory: false, recommended: true },
  ],
  "Kaldera Kids Run": [
    { gear: "Running Shoes", mandatory: true, recommended: false },
    { gear: "ID Card", mandatory: true, recommended: false },
    {
      gear: "Minimum Water Supply of 500ml",
      mandatory: true,
      recommended: false,
    },
  ],
  "Porter Challenge": [
    { gear: "Running Vest/Belt", mandatory: true, recommended: false },
    {
      gear: "Mobile Phone with GPX Route",
      mandatory: true,
      recommended: false,
    },
    {
      gear: "Minimum Water Supply of 500ml",
      mandatory: true,
      recommended: false,
    },
    { gear: "ID Card", mandatory: true, recommended: false },
    { gear: "Whistle", mandatory: true, recommended: false },
    { gear: "Running Shoes", mandatory: true, recommended: false },
  ],
};

// Function untuk mendapatkan gear icon
export const getGearIcon = (gearName) => {
  const gearIconMap = {
    "running vest/belt": "/gears/01.svg",
    "mobile phone with gpx route": "/gears/02.svg",
    smartwatch: "/gears/03.png",
    "minimum water supply of 500ml": "/gears/04.svg",
    "foldable cup": "/gears/05.svg",
    "survival blanket": "/gears/06.svg",
    "first aid kits": "/gears/07.svg",
    "snack/energy bar": "/gears/08.svg",
    "windproof jacket": "/gears/09.svg",
    "rainproof jacket/poncho": "/gears/10.svg",
    "id card": "/gears/11.svg",
    whistle: "/gears/12.svg",
    headlamp: "/gears/13.svg",
    "cap/bandana": "/gears/14.svg",
    "running shoes": "/gears/15.png",
    "sufficient cash": "/gears/16.svg",
    "trekking poles": "/gears/17.png",
  };
  return gearIconMap[gearName.toLowerCase()] || "/gears/default-gear.svg";
};

// Component untuk CheckCircle
export const CheckCircle = () => (
  <span
    className="inline-flex items-center justify-center text-green-600 flex-shrink-0"
    aria-hidden="true"
  >
    <FontAwesomeIcon icon={faCheck} className="text-sm" />
  </span>
);

export const SMMDetail = () => {
  return <div>{/* Your updated SMMDetail content */}</div>;
};
